module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-ExtraBold.d2e1c27.woff2";